module.exports = __webpack_public_path__ + "img/girl.0607b0eb.png";